import { track } from "@amplitude/analytics-react-native";
import { amp } from "src/api/amplitude";
import PillButton from "src/components/PillButton";
import Touchable from "src/components/Touchable";
import IconEdit from "src/icons/IconEdit";
import usePresentGatheringThumbnailEdit from "./hooks/usePresentGatheringThumbnailEdit";

const EditThumbnailOverlay = () => {
	const presentGatheringThumbnailEdit = usePresentGatheringThumbnailEdit({});
	const handlePress = () => {
		track(amp.gathering.enableThumbnailEdit);
		presentGatheringThumbnailEdit();
	};
	return (
		<>
			{/* Image should be clickable */}
			<Touchable
				animation="None"
				onPress={handlePress}
				containerStyle={{
					position: "absolute",
					width: "100%",
					height: "100%",
				}}
			/>
			{/* Avoiding nesting touchables */}
			<PillButton
				testID="EditThumbnail"
				onPress={handlePress}
				Icon={IconEdit}
				containerStyle={{
					position: "absolute",
					bottom: "4%",
					alignSelf: "center",
				}}
				blur
			/>
		</>
	);
};
export default EditThumbnailOverlay;
